// @ts-check
import { Dropdown, Tag } from "antd";
import { IoIosMore as MoreIcon } from "react-icons/io";
import { useHistory } from "react-router";
import { useMembersDataGridContext } from '~/components/AdminPages/MembersDataGrid/MembersDataGrid.context';
import TeamListPopover from '~/components/Shared/TeamListPopover';
import useOrganizationId from "~/hooks/useOrganizationId";
import { UserRole } from '~/other/Constants';
import { safe_get, updateHistoryState } from '~/other/Helper';

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function MemberActionCell({data: user, api}) {
    const { setActiveModal } = useMembersDataGridContext();
    const history = useHistory();
    const orgId = useOrganizationId();
    
    if (!user) {
        return null;
    }

    const menu = {
        items: user.menuOptions,
        onClick: ({ key }) => {
            if (key === "view_profile") {
                updateHistoryState(history, {
                    gridState: api.getState(),
                });
                history.push(`/${orgId}/users/${user.uuid}`);
            } else {
                setActiveModal({key, user});
            }
        },
    };

    return (
        <div className="more" style={{ marginTop: "6px", color: "grey", lineHeight: 0, height: "fit-content" }}>
            <Dropdown
                // @ts-ignore
                menu={menu}
                trigger={["click"]}
            >
                <button className="ButtonLink ant-dropdown-link">
                    <MoreIcon style={{ height: "20px", width: "20px" }} />
                </button>
            </Dropdown>
        </div>
    );
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function MemberRoleCell({data: user}) {
    if (!user) {
        return null;
    }

    const role = user.role || UserRole.INVALID;

    if (role === UserRole.ADMIN) {
        return (
            <p className="role-text zero-dark-grey">
                <span className="badge badge-success badge-icon badge-fw"></span>Admin
            </p>
        );
    } else if (role === UserRole.TEAM_LEAD) {
        return (
            <p className="role-text zero-dark-grey">
                <span className="badge badge-info badge-icon badge-fw"></span>Lead
            </p>
        );
    } else if (role === UserRole.MEMBER) {
        return (
            <p className="role-text zero-dark-grey">
                <span className="badge badge-purple badge-icon badge-fw"></span>Member
            </p>
        );
    } else if (role === UserRole.VIEWER) {
        return (
            <p className="role-text zero-dark-grey">
                <span className="badge badge-danger badge-icon badge-fw"></span>Viewer
            </p>
        );
    } else if (role === UserRole.CONTRIBUTOR) {
        return (
            <p className="role-text zero-dark-grey">
                <span className="badge badge-warning badge-icon badge-fw"></span>Contributor
            </p>
        );
    } else {
        return null;
    }
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function MemberStatusCell({data: user}) {
    if (!user) {
        return null;
    }

    const status = user.status;
    switch (status) {
        case "pending":
            return <Tag color="orange" style={{borderColor: "#FA8C13"}}>Invited</Tag>;
        case "active":
            return <Tag color="green" style={{borderColor: "#52c41a"}}>Registered</Tag>;
        case "deactivated":
            return <Tag style={{color: "#505050"}}>Deactivated</Tag>;
        default:
            return null;
    }
}

/**
 * @param {AgGridReactLib.CustomCellRendererProps} props
 */
export function MemberTeamsCell({data: user}) {
    if (!user) {
        return null;
    }

    const teams = safe_get(user, 'teams', []);
    
    return (
        <div style={{whiteSpace: "normal", color: "var(--zero-dark-grey)"}}>
            <TeamListPopover teams={teams} />
        </div>
    );
}
